export default class AdditionalCoverage {
  private _key!: string
  private _checked!: boolean
  private _value!: number | null

  constructor(data: Partial<AdditionalCoverage> = {}) {
    this.key = data.key ?? ''
    this.checked = data.checked ?? false
    this.value = data.value ?? null
  }

  get key() {
    return this._key
  }
  set key(value: string) {
    this._key = value
  }

  get checked() {
    return this._checked
  }

  set checked(value: boolean) {
    this._checked = value
  }

  get value() {
    return this._value
  }

  set value(value: number | null) {
    this._value = value
  }
}
